import { useState } from 'react'
import { enter, signIn } from '../../lib/auth.js'
import { EntryCard } from '../../classroom/EntryCard.js'
import { Button, FieldLabel } from '../../classroom/ui.js'

export function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError('')

    let result: Awaited<ReturnType<typeof signIn.email>>
    try {
      result = await signIn.email({ email, password })
    } catch {
      // Offline: without this the button stayed on „Loguję…” for good.
      setBusy(false)
      setError('Brak połączenia. Sprawdź internet i spróbuj ponownie.')
      return
    }

    const { data, error: authError } = result
    if (authError) {
      setBusy(false)
      // Wrong credentials stay deliberately vague (never reveal whether the
      // address exists). Anything else is not their mistake, and calling a
      // server restart or a rate limit "wrong password" sent people hunting
      // for a password that was fine.
      setError(
        authError.status === 401 || authError.status === 400
          ? 'Nieprawidłowy e-mail lub hasło.'
          : authError.status === 429
            ? 'Zbyt wiele prób logowania. Spróbuj ponownie za kilka minut.'
            : 'Serwer chwilowo nie odpowiada. Spróbuj ponownie za chwilę.',
      )
      return
    }

    /*
     * One form, two destinations. Students sign in here too — sending
     * everyone to /studio would land them on a panel that answers 403 to
     * every request it makes.
     */
    const role = (data?.user as { role?: string } | undefined)?.role
    // A page load, not navigate() — see enter() in lib/auth.ts.
    enter(role === 'ADMIN' ? '/studio' : '/panel')
  }

  return (
    <EntryCard>
      <form onSubmit={handleSubmit}>
        <h1 className="cl-title m-0">Zaloguj się</h1>
        <p className="m-0 mt-1.5 text-class-ink-soft">Panel ucznia i Studio — jedno logowanie.</p>

        <div className="mt-7 flex flex-col gap-4">
          <div>
            <FieldLabel htmlFor="email">E-mail</FieldLabel>
            <input
              id="email"
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="cl-input"
            />
          </div>
          <div>
            <FieldLabel htmlFor="password">Hasło</FieldLabel>
            <input
              id="password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="cl-input"
            />
          </div>
        </div>

        {error && <p role="alert" className="m-0 mt-4 font-semibold text-class-wrong">✗ {error}</p>}

        <Button type="submit" disabled={busy} className="mt-6 w-full">
          {busy ? 'Loguję…' : 'Zaloguj się'}
        </Button>
      </form>
    </EntryCard>
  )
}
